/**
 * Feature flags for toggling site sections.
 *
 * Set SHOW_APPRENTICESHIP to true to restore availability/alternance sections.
 */
export const SHOW_APPRENTICESHIP = false
